/**
/* © 2023 University of Cambridge
/* SPDX-FileCopyrightText: 2023 University of Cambridge
/* SPDX-License-Identifier: GPL-3.0-or-later
**/

import {prefixInObj} from './utils.js';

export function addLabels(opts, node) {
	// names of individuals
	//addLabel(opts, node, -(0.4 * opts.symbol_size), -(0.1 * opts.symbol_size),
	//	function (d) {
	//		if (opts.DEBUG)
	//			return ('display_name' in d.data ? d.data.display_name : d.data.name) + '  ' + d.data.id;
	//		return 'display_name' in d.data ? d.data.display_name : '';
	//	}, undefined, ['display_name']);

	let font_size = parseInt(getPx(opts)) + 4;

	//first name
	addLabel(opts, node, function (d) {
		return -(opts.symbol_size * d.data.first_name.length / 12);
	}, function (d) {
		return ypos(d, [d.data.first_name], font_size);
	}, function (d) {
		if (opts.DEBUG) return ('first_name' in d.data ? d.data.first_name : d.data.name) + '  ' + d.data.id;
		return 'first_name' in d.data ? d.data.first_name : '';
	}, 'indi_details indi_name', ['first_name']);

	//last name
	addLabel(opts, node, function (d) {
		return -(opts.symbol_size * d.data.last_name.length / 12);
	}, function (d) {
		return ypos(d, [d.data.first_name], font_size);
	}, function (d) {
		if (opts.DEBUG) return ('last_name' in d.data ? d.data.last_name : d.data.name) + '  ' + d.data.id;
		return 'last_name' in d.data ? d.data.last_name : '';
	}, 'indi_details indi_name', ['last_name']);

	// display age/yob label first
	for (let ilab = 0; ilab < opts.labels.length; ilab++) {
		let label = opts.labels[ilab];
		let arr = (Array.isArray(label) ? label : [label]);
		if (arr.indexOf('age') > -1 || arr.indexOf('yob') > -1) {
			addLabel(opts, node, -opts.symbol_size,
				function (d) { return ypos(d, arr, font_size); },
				function (d) { return get_text(d, arr); }, 'indi_details', arr);
		}
	}

	// individuals disease details
	if (opts.showDiseases) {
		for (let i = 0; i < opts.diseases.length; i++) {
			let disease = opts.diseases[i].type;
			addLabel(opts, node, -opts.symbol_size,
				function (d) { return ypos(d, [disease], font_size); },
				function (d) {
					let dis = disease.replace('_', ' ').replace('cancer', 'ca.');
					return disease + '_diagnosis_age' in d.data ? dis + ": " + d.data[disease + '_diagnosis_age'] : '';
				}, 'indi_details', [disease]);
		}
    }

	for (let i = 0; i < opts.dataset.length; i++) {
		if (opts.dataset[i].anatomical_locations) {
			for (let j = 0; j < opts.dataset[i].anatomical_locations.length; j++) {
				addAnatomicalLocationLabel(opts, node, -20, function (d) {
					return ypos(d, [opts.dataset[i].anatomical_locations[j]], font_size) - (0.2 * font_size);
				}, opts.dataset[i].anatomical_locations[j], opts.dataset[i].name);
			}
		}
	}

	// display other labels defined in opts.labels e.g. alleles/genotype data
	for(let ilab=0; ilab<opts.labels.length; ilab++) {
		let label = opts.labels[ilab];
		let arr = (Array.isArray(label) ? label : [label]);
		if(arr.indexOf('age') === -1 && arr.indexOf('yob') === -1) {
			addLabel(opts, node, -opts.symbol_size,
				function(d) { return ypos(d, arr, font_size); },
				function(d) { return get_text(d, arr); }, 'indi_details', arr);
		}
	}
}

function get_text(d, arr) {
	let txt = "";
	for(let l=0; l<arr.length; l++) {
		let this_label = arr[l];
		if(d.data[this_label]) {
			if(this_label === 'alleles') {
				let vars = d.data.alleles.split(';');
				for(let ivar = 0;ivar < vars.length;ivar++) {
					if(vars[ivar] !== "") txt += vars[ivar] + ';';
				}
			} else if(this_label === 'age') {
				txt += d.data[this_label] +'y ';
			} else if(this_label === 'stillbirth') {
				txt += "SB";
			} else if(this_label.match("_gene_test$") && 'result' in d.data[this_label]) {
				let r = d.data[this_label]['result'].toUpperCase();
				//let t = d.data[this_label]['type'];
				if(r !== "-") {
					txt += this_label.replace('_gene_test', '').toUpperCase()
					txt += (r === 'P' ? '+ ' : (r === 'N' ? '- ' : ' '));
				}
			} else if(this_label.match("_bc_pathology$")) {
				let r = d.data[this_label].toUpperCase();
				txt += this_label.replace('_bc_pathology', '').toUpperCase()
				txt += (r === 'P' ? '+ ' : (r === 'N' ? '- ' : ' '));
			} else {
			  txt += d.data[this_label];
			}
		}
	}
	if(txt !== "") return txt;
}

function ypos(d, arr, font_size) {
	if(!node_has_label(d, arr)) return;
	d.y_offset = (!d.y_offset ? font_size*2.35 : d.y_offset+font_size);
	return d.y_offset;
}

function labelIsPropertyValue(value, obj) {
	let found = false;
	if (obj) $.each(obj, function (k, _n) {
		if (_n === value) {
			found = true;
			return found;
		}
	});
	return found;
}

function node_has_label(d, labels) {
	for(let l=0; l<labels.length; l++) {
		if (prefixInObj(labels[l], d.data) || labelIsPropertyValue(labels[l], d.data) || (d.data.anatomical_locations && anatomicalLocationPrefixInObj(labels[l], d.data.anatomical_locations)))
			return true;
	}
	return false;
}

// add label to node
function addLabel(opts, node, fx, fy, ftext, class_label, labels) {
	node.filter(function (d) {
		return !d.data.hidden && (!labels || node_has_label(d, labels));
	}).append("text")
	.attr("class", (class_label ? class_label + ' ped_label' : 'ped_label'))
	.attr("x", fx)
	.attr("y", fy)
	.attr("font-family", opts.font_family)
	.attr("font-size", opts.font_size)
	.attr("font-weight", opts.font_weight)
	.text(ftext);
}

//functions for anatomical location labels
function addAnatomicalLocationLabel(opts, node, fx, fy, ftext, name) {
	node.filter(function (d) {
		return !d.data.hidden && d.data.name === name;
	}).append("text").attr("class", 'indi_details ped_label')
		.attr("x", fx).attr("y", fy)
		.attr("font-family", opts.font_family).attr("font-size", opts.font_size)
		.attr("font-weight", opts.font_weight).text(ftext);
}

function anatomicalLocationPrefixInObj(anatomicalLocation, individualAnatomicalLocations) {
	let found = false;
	if (individualAnatomicalLocations) $.each(individualAnatomicalLocations, function (k, _n) {
		if (_n.indexOf(anatomicalLocation) === 0 || _n === anatomicalLocation) {
			found = true;
			return found;
		}
	});
	return found;
}

// get height in pixels
function getPx(opts){
	let emVal = opts.font_size;
	if (emVal === parseInt(emVal, 10)) // test if integer
		return emVal;

	if(emVal.indexOf("px") > -1)
		return emVal.replace('px', '');
	else if(emVal.indexOf("em") === -1)
		return emVal;
	emVal = parseFloat(emVal.replace('em', ''));
	return (parseFloat(getComputedStyle($('#'+opts.targetDiv).get(0)).fontSize)*emVal)-1.0;
}
